@if (households) {
    <div class="page-content page-fill">
        <div class="row flex-fill">
            <div class="col-5 flex-fill border-end">
                <div class="grid-fill">
                    <dx-data-grid
                        #householdGrid
                        [dataSource]="households"
                        keyExpr="id"
                        [focusedRowEnabled]="true"
                        (focusedRowKeyChange)="onHouseholdSelectionChanged($event)"
                        (onToolbarPreparing)="onToolbarPreparing($event)"
                    >
                        <dxi-column dataField="number" caption="#" width="50px"></dxi-column>
                        <dxi-column dataField="name"></dxi-column>
                        <dxi-column dataField="careCoordinator.displayName" caption="Care Coordinator"></dxi-column>
                        <div *dxTemplate="let data of 'toolbarButtons'">
                            <!-- <dx-button text="Add" type="default" (onClick)="editHousehold()"></dx-button> -->
                            <dx-button text="Edit" type="normal" (onClick)="editHousehold(householdGrid.focusedRowKey)" [disabled]="!householdGrid.focusedRowKey"></dx-button>
                            <button class="ms-2 btn btn-sm btn-primary" (click)="addPerson('CareCoordinator')" [disabled]="!householdGrid.focusedRowKey">Care Coordinator</button>
                        </div>
                        <dxo-selection mode="none"></dxo-selection>
                        <dxo-state-storing [enabled]="true" type="sessionStorage" storageKey="householdsGrid"></dxo-state-storing>
                    </dx-data-grid>
                </div>
            </div>
        </div>
    </div>
}

<dx-popup
    class="popup"
    [width]="400"
    [height]="'auto'"
    [showTitle]="true"
    [title]="(householdEdit?.id > 0 ? 'Edit' : 'New') + ' Household #' + householdEdit?.number"
    [hideOnOutsideClick]="true"
    (onHidden)="householdDialogHidden($event)"
    [(visible)]="householdDialogVisible"
>
    <div *dxTemplate="let data of 'content'">
        <div class="dx-field">
            <div class="dx-field-label" style="width: 25%">Name</div>
            <div class="dx-field-value" style="width: 75%">
                <dx-text-box [(ngModel)]="householdEdit.name" [required]="true"></dx-text-box>
            </div>
        </div>
        <div class="text-end mt-3"><dx-button text="Save" type="default" (onClick)="saveHousehold()"></dx-button></div>
    </div>
</dx-popup>
